// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function useUsersPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canImportUsers = authContext.isAuthorized(true, tenantId, IPermissions.USER_IMPORT);
    var canExportVoters = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_EXPORT);
    var canCreateVoters = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_CREATE);
    var canEditVoters = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_WRITE);
    var canEditVotersWhoVoted = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_VOTED_EDIT);
    var canEditVotersEmailTlf = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_EMAIL_TLF_EDIT);
    var canDeleteVoters = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_DELETE);
    var canImportVoters = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_IMPORT);
    var canManuallyVerify = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_MANUALLY_VERIFY);
    var canChangePassword = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_CHANGE_PASSWORD);
    var showVotersColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_VOTERS_COLUMNS);
    var showVotersFilters = authContext.isAuthorized(true, tenantId, IPermissions.EE_VOTERS_FILTERS);
    var showVotersLogs = authContext.isAuthorized(true, tenantId, IPermissions.EE_VOTERS_LOGS);
    var canSendTemplates = authContext.isAuthorized(true, tenantId, IPermissions.NOTIFICATION_SEND);
    /**
     * Permissions
     */
    return {
        canImportUsers: canImportUsers,
        canCreateVoters: canCreateVoters,
        canEditVoters: canEditVoters,
        canEditVotersWhoVoted: canEditVotersWhoVoted,
        canEditVotersEmailTlf: canEditVotersEmailTlf,
        canDeleteVoters: canDeleteVoters,
        canImportVoters: canImportVoters,
        canExportVoters: canExportVoters,
        canManuallyVerify: canManuallyVerify,
        canChangePassword: canChangePassword,
        showVotersColumns: showVotersColumns,
        showVotersFilters: showVotersFilters,
        showVotersLogs: showVotersLogs,
        canSendTemplates: canSendTemplates,
    };
}
